import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { ColmecWorkOrder } from '../../colmec-working-order-wrapper/colmec-working-order-wrapper.component';
import { Observable } from 'rxjs';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'colmec-working-order-step',
    templateUrl: './colmec-working-order-step.component.html',
    styleUrls: ['./colmec-working-order-step.component.scss'],
    standalone: false
})
export class ColmecWorkingOrderStepComponent implements OnInit {
  @Output()
  public stepDone = new EventEmitter<ColmecWorkOrder>();

  @Output()
  public stepPrevious = new EventEmitter<ColmecWorkOrder>();

  @Output()
  public stepError = new EventEmitter<any>();

  @Input()
  public workingOrder: ColmecWorkOrder;

  @Input()
  public onNextBtnClicked: Observable<void | any>;

  @Input()
  public onPreviousBtnClicked: Observable<void | any>;

  public getLabel(): string {
    return '';
  }

  public getBtnTexts(checkout?: ColmecWorkOrder): { next: string | void; prev: string | void } | void { }

  public isVisible(): boolean {
    return true;
  }

  ngOnInit(): void { }

  protected resetForm(form: FormGroup): void {
    for (const control in form.controls) {
      form.get(control).setValue('');
      form.get(control).markAsUntouched();
      form.get(control).markAsPristine();
    }
  }
}
